import { esgGetBadgeClass } from '../../../helpers/issue/esg-type';
import {
  ESGCertType,
  ESGCertVerifier,
  ESGCertification
} from '../../../types/deal.types';

export interface ESGValues {
  badgeClass?: string;
  esgCertType: ESGCertType;
  esgCertTypes?: ESGCertType[];
  esgCertVerifier: ESGCertVerifier;
  esgCertVerifiers?: ESGCertVerifier[];
  esgPreapprovedInd: boolean;
  esgPreapprovedInds?: boolean[];
}

export function esgValueGetter(node): ESGValues {
  const esgCert = node.data.series
    .map(series => series.esgCertification)
    .reduce(variousReduceESGCertification, {
      esgCertType: null,
      esgCertTypes: [],
      esgCertVerifier: null,
      esgCertVerifiers: [],
      esgPreapprovedInd: null,
      esgPreapprovedInds: []
    });

  if (esgCert) {
    return {
      ...esgCert,
      badgeClass: esgGetBadgeClass(esgCert)
    };
  }

  return null;
}

export function getRefinedEsgData(data: ESGCertification[]): ESGValues {
  if (!data || data.every(ea => !ea || !ea.esgCertType)) return null;

  const rData = data.filter(ea => !!ea);
  const fCertType = rData[0].esgCertType;
  const fCertVerifier = rData[0].esgCertVerifier;

  if (
    rData.every(
      ea =>
        !!ea.esgCertType &&
        ea.esgCertType === fCertType &&
        ea.esgCertVerifier === fCertVerifier
    )
  ) {
    return rData[0];
  } else {
    return {
      esgCertType: ESGCertType.Various,
      esgCertVerifier: ESGCertVerifier.Various,
      esgPreapprovedInd: false
    };
  }
}

export function variousReduceESGCertification(
  prev: ESGValues,
  curr: ESGValues,
  index: number,
  arr: ESGValues[]
): ESGValues {
  if (arr.every(ea => !ea)) {
    return null;
  } else {
    if (curr) {
      if (
        prev.esgCertTypes.indexOf(curr.esgCertType) === -1 &&
        !!curr.esgCertType
      ) {
        prev.esgCertTypes.push(curr.esgCertType);
      }

      if (
        prev.esgCertVerifiers.indexOf(curr.esgCertVerifier) === -1 &&
        !!curr.esgCertVerifier
      ) {
        prev.esgCertVerifiers.push(curr.esgCertVerifier);
      }

      if (!prev.esgPreapprovedInds.includes(!!curr.esgPreapprovedInd)) {
        prev.esgPreapprovedInds.push(!!curr.esgPreapprovedInd);
      }

      return {
        esgCertType: curr.esgCertType,
        esgCertTypes: prev.esgCertTypes,
        esgCertVerifier: curr.esgCertVerifier,
        esgCertVerifiers: prev.esgCertVerifiers,
        esgPreapprovedInd: curr.esgPreapprovedInd,
        esgPreapprovedInds: prev.esgPreapprovedInds
      };
    } else {
      return {
        esgCertType: prev.esgCertType,
        esgCertTypes: prev.esgCertTypes,
        esgCertVerifier: prev.esgCertVerifier,
        esgCertVerifiers: prev.esgCertVerifiers,
        esgPreapprovedInd: prev.esgPreapprovedInd,
        esgPreapprovedInds: prev.esgPreapprovedInds
      };
    }
  }
}
